import Vue from "vue";
import "./cube-ui";
import App from "./App.vue";
import router from "./router";
import "./permission";
import store from "./store";

// 移动端调试面板（通过 ?debug=1 开启）
if (process.env.NODE_ENV === 'development' || /[?&]debug=1/.test(location.search)) {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole();
  });
}

//import  from "axios";
import KHeader from "./components/Header.vue";
import { createAPI } from "cube-ui";
import Notice from "./components/Notice.vue";
import notice from "@/services/notice";

Vue.config.productionTip = false;

// 全局引入Header.vue
Vue.component("k-header", KHeader);

//Vue.prototype.$http = axios;
Vue.prototype.$notice = notice;

// 创建$createNotice API
createAPI(Vue, Notice, true); // 参数3表示单例模式

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
